import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

export const axios = require('axios').default;

//axios.defaults.baseURL = "https://o2o-dev.miserver.it.umich.edu";
//axios.defaults.baseURL = "http://localhost:10000";
axios.defaults.baseURL = "https://api.open2options.org";
//axios.defaults.baseURL = "https://umich-o2ostudy.org";
//axios.defaults.baseURL = "https://api.open2options.org";

//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
//axios.defaults.headers.common["Referrer Policy"] = "no-referrer";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.withCredentials = true;



function saveMessageToServer(sessionID, message) {
  let messages_url = "/api/chat/messages/" + sessionID + "/";
  axios.post(messages_url, {
    "session": sessionID,
    "message_type": message.type,
    "message_options": JSON.stringify(message.options)
  })
    .then(function (response) {
      // console.log(response);
    })
    .catch(function (error) {
      console.log(error);
      window.location.replace("/login");
    });
}

var syncingMessages = false;

function syncMessages() {
  if (syncingMessages) return;
  syncingMessages = true;

  let sessionID = store.state.sessionID;
  let messages = store.state.messagesData;

  // axios.defaults.headers.common['Authorization'] = 'Token ' + token; // d383bed76af74e08e864ebb6cd86901e9d6ee046';
  let messages_url = "/api/chat/messages/" + sessionID + "/";

  axios.get(messages_url)
    .then(function (response) {
      // console.log(response);
      var server_messages = response.data;
      server_messages.sort(function (a, b) {
        if (a.created > b.created) {
          return -1;
        }

        if (b.created > a.created) {
          return 1;
        }

        return 0;
      });

      var messages_to_sync;

      if (server_messages.length > 0 && messages.length > server_messages.length) {
        messages_to_sync = messages.slice(server_messages.length);
      }
      else {
        if (server_messages.length == 0) {
          messages_to_sync = messages;
        }
        else {
          let latest_timestamp = new Date(server_messages[0].created).getTime() - 30 * 1000;
          messages_to_sync = messages.filter(message => new Date(message.timestamp).getTime() > latest_timestamp)
        }
      }

      for (let message_index in messages_to_sync) {
        saveMessageToServer(sessionID, messages_to_sync[message_index])
        console.log("Saved " + messages_to_sync[message_index].type + " to server.");
      }

      syncingMessages = false;
    })
    .catch(function (error) {
      console.log(error);
      window.location.replace("#/login");
      syncingMessages = false;
    })
}


export function syncSessionOnServer() {
  let sessionID = store.state.sessionID;
  let current_section_name = store.state.currentSectionName;
  let chat_responses = store.state.chatResponses;
  let summary_responses = store.state.summaryResponses;
  let finalized = store.state.sessionFinalized;
  if (sessionID === null) {
    window.location.replace("#/profile");
  } else {
    let messages_url = "/api/chat/sessions/" + sessionID + "/";

//function getCsrfToken() {
//  return document.cookie.match("(^|;)\\s*" + "csrftoken" + "\\s*=\\s*([^;]+)")?.pop();
//}
   //  let csrftoken = getCsrfToken();
function getCookie(name) {
      let cookieValue = null;
      if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim();
          // Does this cookie string begin with the name we want?
          if (cookie.substring(0, name.length + 1) === (name + '=')) {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
            break;
          }
        }
      }
      return cookieValue;
    }
   
     const csrftoken = getCookie('csrftoken');
     let headers = {
        "X-CSRFToken": csrftoken,
        "Content-Type": "application/x-www-form-urlencoded"
        };
    axios.put(messages_url, {
      "chat_responses": JSON.stringify(chat_responses),
      "summary_responses": JSON.stringify(summary_responses),
      "current_section_name": current_section_name,
      "finalized": finalized
    }, headers)
      .then(function (response) {
        
      })
      .catch(function (error) {
        console.log(error);
        window.location.replace("#/profile");
      });
  }
}

store.watch(function (state) { return state.messagesData },
  syncMessages
)

store.watch(function (state) { return state.chatResponses },
  syncSessionOnServer
)

store.watch(function (state) { return state.summaryResponses },
  syncSessionOnServer
)

store.watch(function (state) { return state.currentSectionName },
  syncSessionOnServer
)

store.watch(function (state) { return state.sessionFinalized },
  syncSessionOnServer
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
